import { ButtonType } from '../../../../types/button.types';

export interface AtomButtonProps {
  label: string;
  type: ButtonType;
}

export interface AtomButton extends AtomButtonProps {
  notifyClick(): void;
}

export interface Button {
  link?: string;
  label: string;
  icon?: string;
  screenReaderLabel?: string;
  id?: string;
}
